
export class MensagensUteis  {
    public descricao:string;
   
}
